import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import RatingStars from "../ui/RatingStars";

const TestimonialForm = ({
  formData,
  onFieldChange,
  onPhotoChange,
  onSubmit,
  submitLabel = "Submit Feedback",
  isSubmitting = false,
  submitDisabled = false,
  showCaptcha = false,
}) => {
  return (
    <form onSubmit={onSubmit} className="mt-6 grid gap-4 md:grid-cols-2">
      <input
        type="text"
        name="fullName"
        value={formData.fullName}
        onChange={onFieldChange}
        placeholder="Full Name"
        required
        className="rounded-xl border border-gray-300 bg-white px-4 py-3 focus:border-maroon focus:outline-none"
      />
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={onFieldChange}
        placeholder="Email Address"
        required
        className="rounded-xl border border-gray-300 bg-white px-4 py-3 focus:border-maroon focus:outline-none"
      />
      <input
        type="text"
        name="company"
        value={formData.company}
        onChange={onFieldChange}
        placeholder="Company Name (Optional)"
        className="rounded-xl border border-gray-300 bg-white px-4 py-3 focus:border-maroon focus:outline-none md:col-span-2"
      />

      <div className="md:col-span-2">
        <p className="mb-2 text-sm font-medium text-gray-700">Rating</p>
        <RatingStars
          value={formData.rating}
          size="text-2xl"
          onChange={(rating) =>
            onFieldChange({
              target: {
                name: "rating",
                value: rating,
              },
            })
          }
        />
      </div>

      <textarea
        name="message"
        value={formData.message}
        onChange={onFieldChange}
        placeholder="Share your experience..."
        rows={5}
        required
        className="rounded-xl border border-gray-300 bg-white px-4 py-3 focus:border-maroon focus:outline-none md:col-span-2"
      />

      <div className="md:col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-700">Image Upload</label>
        <input
          type="file"
          accept="image/*"
          onChange={onPhotoChange}
          className="w-full rounded-xl border border-gray-300 bg-white px-4 py-3"
        />
      </div>

      {showCaptcha ? (
        <div className="md:col-span-2">
          <ReCAPTCHA
            sitekey="6Le82-krAAAAAJqdbcRPwQlXhDf5XS_HE-68-LsB"
            onChange={() => {}}
          />
        </div>
      ) : null}

      <button
        type="submit"
        disabled={submitDisabled || isSubmitting || !formData.rating}
        className="md:col-span-2 rounded-full bg-maroon px-6 py-3 font-semibold text-white transition hover:bg-maroon/90 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isSubmitting ? "Saving..." : submitLabel}
      </button>
    </form>
  );
};

export default TestimonialForm;
